import React from "react";
import "./Contacts.css";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import contactUsImage from "../../assets/contact_us_1.jpg";

const Contacts = () => {
  return (
    <div className="contact-page">
      <div className="flex-row flex-wrap mb-10 contact-details">
        <div className="contact-us-image">
          <img
            src={contactUsImage}
            alt="Contact Us"
            className="contact-image"
          />
        </div>

        <div className="physical-address">
          <ul>
            <li>Bank Of Tanzania</li>
            <li>2 Mirambo Street</li>
            <li>P.O Box 2939</li>
            <li>11884 Dar es salaam - Tanzania</li>
            <li className="flex-row align-item-center">
              <LocalPhoneIcon />
              Tel: <a href="tel:+255 26 2963182">+255 26 2963182</a>
            </li>
            <li className="flex-row align-item-center">
              <LocalPhoneIcon />
              Toll-free : <a href="tel:255 26 2963182">+255 26 2963182</a>
            </li>
            <li className="flex-row align-item-center">
              <EmailIcon />
              Email :{" "}
              <a href="email:tz-fincert@bot.go.tz">tz-fincert@bot.go.tz</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="google-map contact-footer">
        <iframe
          title="TzFincert Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31692.964643016665!2d39.25589737431641!3d-6.815917599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4b10c882b23f%3A0xf78b4b26668c0cfa!2sBank%20of%20Tanzania!5e0!3m2!1sen!2stz!4v1729850377009!5m2!1sen!2stz"
          width="100%"
          height="100%"
          style={{ border: "0" }}
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contacts;
